import $ from 'jquery';
import debounce from '../lib/utils/debounce';

const selectors = {
    elem: '.tabs-accordion',
    option: '.tabs-accordion__option',
    tabsInner: '.tabs-accordion__tabs-inner',
    tab: '.tabs-accordion__tab',
    section: '.tabs-accordion__section'
};

const states = {
    activeOption: 'tabs-accordion__option--active',
    activeTab: 'tabs-accordion__tab--active',
    activeSection: 'tabs-accordion__section--active'
};

const DESKTOP_BREAKPOINT = '(min-width: 1230px)';
const mediaQueryList = window.matchMedia(DESKTOP_BREAKPOINT);

const DEBOUNCE_TIMEOUT = 200;

const MODE_TYPES = {
    mobile: 0,
    desktop: 1
};

const isDesktopMode = () => mediaQueryList.matches;

let currentMode;
let previousMode;
let modeChanged = false;

const hasModeChanged = () => {
    modeChanged = currentMode !== previousMode;

    if (modeChanged) {
        previousMode = currentMode;
    }

    return modeChanged;
};

const setSectionHeight = function ($slider, $section) {
    const tabsInnerHeight = $slider.find(selectors.tabsInner).outerHeight();
    const sectionHeight = $section.outerHeight();

    if (tabsInnerHeight > sectionHeight) {
        $section.css('height', `${tabsInnerHeight}px`);
        return tabsInnerHeight;
    }

    return sectionHeight;
};

const onOptionClick = function (evt) {
    evt.preventDefault();

    const $this = $(evt.currentTarget);

    const $targetSection = $($this.attr('href'));

    $this.toggleClass(states.activeOption);

    $targetSection.stop().slideToggle({
        complete() {
            $(this).toggleClass(states.activeSection)
                .removeAttr('style');
        }
    });
};

const actionTabClick = function ($this) {

    if ($this.hasClass(states.activeTab)) {
        return;
    }

    const $elem = $this.closest(selectors.elem);
    const $targetSection = $($this.attr('href'));

    $elem.find(`.${states.activeTab}`)
        .removeClass(states.activeTab);

    $elem.find(`.${states.activeSection}`)
        .removeClass(states.activeSection)
        .removeAttr('style');

    $this.addClass(states.activeTab);

    setSectionHeight($elem, $targetSection);

    $targetSection.addClass(states.activeSection);
};

const onTabClick = function (evt) {
    evt.preventDefault();

    const $this = $(evt.currentTarget);
    actionTabClick($this);
};


const unsetMobileMode = ($elem) => {
    $elem.find(selectors.option).removeClass(states.activeOption);
    $elem.off('click', `${selectors.option}`, onOptionClick);
};

const unsetDesktopMode = ($elem) => {
    $elem.find(selectors.tab).removeClass(states.activeTab);
    $elem.off('click', `${selectors.tab}`, onTabClick);
};

const setDesktopMode = ($elem) => {
    unsetMobileMode($elem);

    $elem.on('click', `${selectors.tab}`, onTabClick);

    // If there're multiple accordions on the page
    // we need to select the first tab and section in each accordion
    $elem.each((index, accordion) => {
        const $accordion = $(accordion);

        $accordion.find(selectors.tab).removeClass(states.activeTab)
            .eq(0).addClass(states.activeTab);

        const $sections = $accordion.find(selectors.section)
            .removeAttr('style').removeClass(states.activeSection);

        const $activeSection = $sections.eq(0);

        setSectionHeight($accordion, $activeSection);

        $activeSection.addClass(states.activeSection);
    });
};

const setMobileMode = function ($elem) {
    unsetDesktopMode($elem);

    $elem.on('click', `${selectors.option}`, onOptionClick);

    $elem.find(selectors.option).removeClass(states.activeOption);
    $elem.find(selectors.section).removeAttr('style').removeClass(states.activeSection);
};

export default {
    init() {
        const $tabsAccordion = $(selectors.elem);

        if (!$tabsAccordion.length) {
            return;
        }

        currentMode = previousMode = isDesktopMode() ? MODE_TYPES.desktop : MODE_TYPES.mobile;

        if (isDesktopMode()) {
            currentMode = previousMode = MODE_TYPES.desktop;
            setDesktopMode($tabsAccordion);
        } else {
            currentMode = previousMode = MODE_TYPES.mobile;
            setMobileMode($tabsAccordion);
        }

        const onScreenChange = () => {
            currentMode = isDesktopMode() ? MODE_TYPES.desktop : MODE_TYPES.mobile;

            if (!hasModeChanged()) {
                return;
            }

            if (isDesktopMode()) {
                setDesktopMode($tabsAccordion);
            } else {
                setMobileMode($tabsAccordion);
            }
        };

        const debouncedOnScreenChange = debounce(onScreenChange, DEBOUNCE_TIMEOUT);

        $(window).on('resize', debouncedOnScreenChange);
    }
};
